<ion-row class="overflow-auto">
	<ion-col>
		<div [innerHTML]="desc | langObservable | async" role="region" aria-label="Description"></div>
		<ion-button (click)="dismiss()" class="white">
			{{ 'short_info.close' | translate }}
		</ion-button>
	</ion-col>
</ion-row>
